// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dFXi9DaqByJUHWHOTwQS {
  width: 100%;
  background-color: var(--white);
  margin-bottom: 6rem;
}

.ltczeVAhoiYdmRE3jl9X {
  padding: 0 var(--horizontal-padding);
  max-width: 90rem;
  margin: 5.625rem auto 0 auto;
}

.lvc9Betu8bdKtQqHVHyJ {
  display: flex;
  flex-direction: column;
  grid-gap: 5.625rem;
  gap: 5.625rem
}

.lvc9Betu8bdKtQqHVHyJ .pU_PQnjpGynVcYnTCisw:nth-child(even) {
      flex-direction: row-reverse;
    }

@media only screen and
  (min-width: 1280px) {
  .ltczeVAhoiYdmRE3jl9X {
    --horizontal-padding: 4rem;
  }
}

@media only screen and
  (min-width: 1024px) and
  (max-width: 1279px) {
  .ltczeVAhoiYdmRE3jl9X {
    --horizontal-padding: 3rem;
  }
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
  .ltczeVAhoiYdmRE3jl9X {
    --horizontal-padding: 2rem;

    margin: 3.125rem auto 0 auto;
  }

  .lvc9Betu8bdKtQqHVHyJ {
    grid-gap: 2.5rem;
    gap: 2.5rem
  }
      .lvc9Betu8bdKtQqHVHyJ .pU_PQnjpGynVcYnTCisw:nth-child(even) {
        flex-direction: column-reverse;
      }
}

@media only screen and
  (max-width: 639px) {
  .dFXi9DaqByJUHWHOTwQS {
    margin-bottom: 2.5rem;
  }

  .ltczeVAhoiYdmRE3jl9X {
    --horizontal-padding: 1rem;

    margin: 2.5rem auto 0 auto;
  }

  .lvc9Betu8bdKtQqHVHyJ {
    grid-gap: 2.5rem;
    gap: 2.5rem
  }
      .lvc9Betu8bdKtQqHVHyJ .pU_PQnjpGynVcYnTCisw:nth-child(even) {
        flex-direction: column-reverse;
      }
}
`, "",{"version":3,"sources":["webpack://./src/components/ContentBlocksSection/ContentBlocksSection.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,gBAAiB;EACjB,4BAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAS;EAAT;AAOF;;AAJI;MACE,2BAA2B;IAC7B;;AAIJ;;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;;;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;;;EACE;IACE,0BAA0B;;IAE1B,4BAAwB;EAC1B;;EAEA;IACE,gBAAS;IAAT;EAOF;MAJI;QACE,8BAA8B;MAChC;AAGN;;AAEA;;EACE;IACE,qBAAmB;EACrB;;EAEA;IACE,0BAA0B;;IAE1B,0BAAwB;EAC1B;;EAEA;IACE,gBAAS;IAAT;EAOF;MAJI;QACE,8BAA8B;MAChC;AAGN","sourcesContent":[".contentBlocksSection {\n  width: 100%;\n  background-color: var(--white);\n  margin-bottom: 96px;\n}\n\n.contentBlocksSectionInner {\n  padding: 0 var(--horizontal-padding);\n  max-width: 1440px;\n  margin: 90px auto 0 auto;\n}\n\n.items {\n  display: flex;\n  flex-direction: column;\n  gap: 90px;\n\n  & .imagesAlternation {\n    &:nth-child(even) {\n      flex-direction: row-reverse;\n    }\n  }\n}\n\n@media (--desktop-large) {\n  .contentBlocksSectionInner {\n    --horizontal-padding: 64px;\n  }\n}\n\n@media (--desktop-small) {\n  .contentBlocksSectionInner {\n    --horizontal-padding: 48px;\n  }\n}\n\n@media (--tablet) {\n  .contentBlocksSectionInner {\n    --horizontal-padding: 32px;\n\n    margin: 50px auto 0 auto;\n  }\n\n  .items {\n    gap: 40px;\n\n    & .imagesAlternation {\n      &:nth-child(even) {\n        flex-direction: column-reverse;\n      }\n    }\n  }\n}\n\n@media (--mobile) {\n  .contentBlocksSection {\n    margin-bottom: 40px;\n  }\n\n  .contentBlocksSectionInner {\n    --horizontal-padding: 16px;\n\n    margin: 40px auto 0 auto;\n  }\n\n  .items {\n    gap: 40px;\n\n    & .imagesAlternation {\n      &:nth-child(even) {\n        flex-direction: column-reverse;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentBlocksSection": `dFXi9DaqByJUHWHOTwQS`,
	"contentBlocksSectionInner": `ltczeVAhoiYdmRE3jl9X`,
	"items": `lvc9Betu8bdKtQqHVHyJ`,
	"imagesAlternation": `pU_PQnjpGynVcYnTCisw`
};
export default ___CSS_LOADER_EXPORT___;
